import {
  MAX_MANUAL_PHONE_LENGTH,
  MIN_MANUAL_PHONE_LENGTH,
} from 'view/pages/DiscountEditor/components/CompanyInfoForm/CompanyInfoForm.constants';
import { CountryWithPhoneFormat } from 'config';
import { getValidPhoneNumberLength } from './phoneNumberMasks';

export const validatePhoneLength = ({
  phoneNumber,
  country,
  isManualCountryCodeInput,
  allowEmpty,
}: {
  phoneNumber: string;
  country: string | undefined;
  isManualCountryCodeInput: boolean;
  allowEmpty: boolean;
}) => {
  const { length } = phoneNumber.replace(/\D/g, '');

  if (allowEmpty && !length) {
    return true;
  }

  if (isManualCountryCodeInput) {
    return (
      length >= MIN_MANUAL_PHONE_LENGTH && length <= MAX_MANUAL_PHONE_LENGTH
    );
  }

  if (country === CountryWithPhoneFormat.Hungary) {
    return (getValidPhoneNumberLength(country) as number[]).includes(length);
  }

  return length === getValidPhoneNumberLength(country);
};
